import React from 'react';
import { FormattedMessage } from 'react-intl';
import { array, bool } from 'prop-types';
import NewsPromoListItem from '../NewsPromoListItem';

const propTypes = {
  promotions: array.isRequired,
  inNewsItem: bool,
};

const defaultProps = {
  promotions: [],
};

const NewsPromoList = ({ promotions, inNewsItem }) =>
  promotions.length > 0 ? (
    <div className="news-promo-list">
      {promotions.map(promo => (
        <NewsPromoListItem key={promo.id} {...promo} inNewsItem={inNewsItem} />
      ))}
    </div>
  ) : (
      <div className="card-empty">
        <FormattedMessage id="news.special.no-offers" defaultMessage="No Special Offers" />
      </div>
    );

NewsPromoList.propTypes = propTypes;
NewsPromoList.defaultProps = defaultProps;

export default NewsPromoList;
